<ul ngTree #tree="ngTree" [(value)]="selected" class="basic-tree">
  <ng-template
    [ngTemplateOutlet]="treeNodes"
    [ngTemplateOutletContext]="{ nodes: nodes, parent: tree }"
  />
</ul>
<ng-template #treeNodes let-nodes="nodes" let-parent="parent">
  @for (node of nodes; track node.name) {
    <li
      ngTreeItem
      [parent]="parent"
      [value]="node.value"
      [label]="node.name"
      [disabled]="node.disabled"
      [(expanded)]="node.expanded"
      #treeItem="ngTreeItem"
    >
      <icon
        [class.invisible]="!node.children?.length"
        aria-hidden="true"
        class="expand-icon"
        [iconDefinition]="'Chevron_Right'"
      ></icon>

      @if (node.icon) {
        <icon aria-hidden="true" [iconDefinition]="node.icon"></icon>
      }

      {{ node.name }}

      <icon
        aria-hidden="true"
        class="selected-icon"
        [iconDefinition]="'Check'"
      ></icon>
    </li>
    @if (node.children?.length) {
      <ul role="group">
        <ng-template
          ngTreeItemGroup
          [ownedBy]="treeItem"
          #group="ngTreeItemGroup"
        >
          <ng-template
            [ngTemplateOutlet]="treeNodes"
            [ngTemplateOutletContext]="{ nodes: node.children, parent: group }"
          />
        </ng-template>
      </ul>
    }
  }
</ng-template>
